import $ajax from './../script/ajax'
import { permission } from '../config/apis'

export default {
  roleListOrg: (params, options) => {
    return $ajax(Object.assign({ ...permission.roleListOrg, data: params }, options))
  },
  roleList: (params, options) => {
    return $ajax(Object.assign({ ...permission.roleList, data: params }, options))
  },
  //用户权限(菜单) 树
  menuTree: (params, options) => {
    return $ajax(Object.assign({ ...permission.menuTree, data: params }, options))
  }
}



// WEBPACK FOOTER //
// ./src/apis/permission.js